import template from '../ui/templates/modal/prompt.hbs';
import longTemplate from '../ui/templates/modal/long-prompt.hbs';

class PromptModal {
  constructor ({ long, wrapper, title, label, defaultValue }) {
    this.long = long;
    this.$wrapper = $(
      wrapper
        ? $.parseHTML(wrapper)
        : $.parseHTML('<div class="tool-content"></div>')
    );

    const t = long ? longTemplate : template;

    this.$wrapper.append(
      t({
        title,
        label,
        default_value: defaultValue
      })
    );
  }

  getFormHtml () {
    return this.$wrapper;
  }

  getValue () {
    return this.long
      ? this.$wrapper.find('textarea').val()
      : this.$wrapper.find('input').val();
  }
}

module.exports = PromptModal;
